import React, { createContext, useContext, useState } from 'react';

const AdminContext = createContext();

export const useAdminContext = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdminContext must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [admin, setAdmin] = useState(null);

  // Demo admin credentials
  const demoAdmin = {
    email: 'admin@minecraft-jordan.com',
    password: 'admin123',
    name: 'System Administrator'
  };

  const login = async (email, password) => {
    // Simple authentication for demo purposes
    if (email === demoAdmin.email && password === demoAdmin.password) {
      setIsAuthenticated(true);
      setAdmin({ email: demoAdmin.email, name: demoAdmin.name });
      return true;
    } else {
      throw new Error('Invalid credentials');
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    setAdmin(null);
  };

  const value = {
    isAuthenticated,
    admin,
    login,
    logout
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};